exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overflow-on .cell {\r\n  overflow: visible;\r\n  overflow-x: visible;\r\n  overflow-y: visible;\n}\n.el-table__row button {\r\n  margin: 5px;\n}\r\n", ""]);

// exports
